/** @format */

import React from "react";

const Grid = ({ data }) => {
  // const arr = Array(4).fill(0);

  return (
    <div className='grid'>
      <div className='grid__item grid__item--1'>
        <svg
          width='150'
          height='123'
          viewBox='0 0 150 123'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          className='grid__icon'>
          <path
            opacity='0.15'
            d='M103.787 33.8045V29.875C103.787 12.2622 76.7714 -1 40.8935 -1C5.01562 -1 -22 12.2622 -22 29.875V57.9432C-22 72.6088 -3.27489 84.2571 23.7407 87.7656V91.625C23.7407 109.238 50.7564 122.5 86.6343 122.5C122.512 122.5 149.528 109.238 149.528 91.625V63.5568C149.528 49.0315 131.374 37.3832 103.787 33.8045ZM23.7407 76.3278V59.6974C29.4288 60.4151 35.1587 60.7667 40.8935 60.75C46.6284 60.7667 52.3582 60.4151 58.0463 59.6974V76.3278C52.372 77.196 46.6362 77.6183 40.8935 77.5909C35.1508 77.6183 29.415 77.196 23.7407 76.3278ZM92.3518 48.0491V57.9432C92.3518 63.8375 83.4896 70.1528 69.4815 74.0122V57.5923C78.7011 55.417 86.4913 52.119 92.3518 48.0491ZM-10.5648 57.9432V48.0491C-4.70428 52.119 3.08594 55.417 12.3056 57.5923V74.0122C-1.70255 70.1528 -10.5648 63.8375 -10.5648 57.9432ZM35.1759 91.625V88.6778L40.8935 88.8182C43.7047 88.8182 46.4205 88.748 49.0411 88.6077C51.8999 89.5901 54.9016 90.4321 58.0463 91.204V107.694C44.0382 103.835 35.1759 97.5193 35.1759 91.625ZM69.4815 110.01V93.3091C75.1689 94.0417 80.8981 94.4167 86.6343 94.4318C92.3691 94.4486 98.0989 94.097 103.787 93.3793V110.01C92.4162 111.694 80.8523 111.694 69.4815 110.01ZM115.222 107.694V91.2741C124.442 89.0989 132.232 85.8008 138.093 81.731V91.625C138.093 97.5193 129.23 103.835 115.222 107.694Z'
            fill='#FCE7C3'
          />
        </svg>
        <p>الرصيـــــد الكــلي</p>
        <h2>{data.orders_total} د.ك</h2>
      </div>
      <div className='grid__item grid__item--2'>
        <svg
          width='96'
          height='102'
          viewBox='0 0 96 102'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          className='grid__icon'>
          <g opacity='0.15'>
            <circle cx='33.5' cy='39.5' r='62.5' fill='#00A02D' />
            <path
              d='M25.3829 59.3864L5.09073 39.2687L11.5437 33.0065L25.3829 46.5861L55.4519 16.7728L61.9089 23.1729L25.3829 59.3864Z'
              fill='white'
            />
          </g>
        </svg>
        <p> طلبــــات تمـــت</p>
        <h2>{data.orders_competed}</h2>
      </div>
      <div className='grid__item grid__item--3'>
        <svg
          width='96'
          height='102'
          viewBox='0 0 96 102'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          className='grid__icon'>
          <g opacity='0.15'>
            <circle cx='33.5' cy='39.5' r='62.5' fill='#FF8900' />
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M28.3864 62.7954C28.3864 63.8503 27.9673 64.8619 27.2214 65.6078C26.4756 66.3537 25.4639 66.7727 24.4091 66.7727H20.4318C19.377 66.7727 18.3653 66.3537 17.6195 65.6078C16.8736 64.8619 16.4545 63.8503 16.4545 62.7954V15.0682C16.4545 14.0133 16.8736 13.0017 17.6195 12.2558C18.3653 11.5099 19.377 11.0909 20.4318 11.0909H24.4091C25.4639 11.0909 26.4756 11.5099 27.2214 12.2558C27.9673 13.0017 28.3864 14.0133 28.3864 15.0682V62.7954ZM56.2273 62.7954C56.2273 63.8503 55.8082 64.8619 55.0624 65.6078C54.3165 66.3537 53.3048 66.7727 52.25 66.7727H48.2727C47.2179 66.7727 46.2063 66.3537 45.4604 65.6078C44.7145 64.8619 44.2955 63.8503 44.2955 62.7954V15.0682C44.2955 14.0133 44.7145 13.0017 45.4604 12.2558C46.2063 11.5099 47.2179 11.0909 48.2727 11.0909H52.25C53.3048 11.0909 54.3165 11.5099 55.0624 12.2558C55.8082 13.0017 56.2273 14.0133 56.2273 15.0682V62.7954Z'
              fill='white'
            />
          </g>
        </svg>
        <p> طلبــــات قيد الانتظار</p>
        <h2>{data.orders_pending}</h2>
      </div>
      <div className='grid__item grid__item--4'>
        <svg
          width='96'
          height='102'
          viewBox='0 0 96 102'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          className='grid__icon'>
          <g opacity='0.15'>
            <circle cx='33.5' cy='39.5' r='62.5' fill='#FF002E' />
            <path
              d='M38.5815 38.9585L55.7089 21.8709C56.459 21.1209 56.8803 20.1036 56.8803 19.0429C56.8803 17.9822 56.459 16.9649 55.7089 16.2149C54.9589 15.4649 53.9416 15.0435 52.8809 15.0435C51.8202 15.0435 50.8029 15.4649 50.0529 16.2149L32.9653 33.3423L15.8777 16.2149C15.1277 15.4649 14.1104 15.0435 13.0497 15.0435C11.989 15.0435 10.9717 15.4649 10.2217 16.2149C9.47164 16.9649 9.05028 17.9822 9.05028 19.0429C9.05028 20.1036 9.47164 21.1209 10.2217 21.8709L27.3491 38.9585L10.2217 56.0461C9.84835 56.4164 9.55203 56.8569 9.34981 57.3423C9.14759 57.8277 9.04348 58.3483 9.04348 58.8741C9.04348 59.3999 9.14759 59.9205 9.34981 60.4059C9.55203 60.8913 9.84835 61.3318 10.2217 61.7021C10.592 62.0755 11.0325 62.3718 11.5179 62.574C12.0033 62.7762 12.5239 62.8803 13.0497 62.8803C13.5755 62.8803 14.0961 62.7762 14.5815 62.574C15.0669 62.3718 15.5074 62.0755 15.8777 61.7021L32.9653 44.5747L50.0529 61.7021C50.4232 62.0755 50.8637 62.3718 51.3491 62.574C51.8345 62.7762 52.3551 62.8803 52.8809 62.8803C53.4067 62.8803 53.9273 62.7762 54.4127 62.574C54.8981 62.3718 55.3386 62.0755 55.7089 61.7021C56.0822 61.3318 56.3786 60.8913 56.5808 60.4059C56.783 59.9205 56.8871 59.3999 56.8871 58.8741C56.8871 58.3483 56.783 57.8277 56.5808 57.3423C56.3786 56.8569 56.0822 56.4164 55.7089 56.0461L38.5815 38.9585Z'
              fill='white'
            />
          </g>
        </svg>
        <p> طلبات لم تتم</p>
        <h2>{data.orders_cancelled}</h2>
      </div>
    </div>
  );
};
export default Grid;
